import {  Collapse} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const BannerComponent = ({bannerMessage, bannerWidth})=>{
    return (
        <div>
            <Collapse in={bannerMessage !== ''}>
                <Alert icon="!" style={{width:bannerWidth, boxSizing: 'border-box'}}>
                    <div dangerouslySetInnerHTML={{__html: bannerMessage}}></div>
                </Alert>
            </Collapse>
        </div>
     );   
};
export default BannerComponent
